/**
 * Hero Banner Carousel Dots Functionality
 * Extracted from sections/zbrands-hero-banner.liquid for reusability
 */

document.addEventListener('DOMContentLoaded', function() {
  // Ensure hero banner carousel dots functionality
  function initHeroBannerDots() {
    const heroBannerSection = document.querySelector('.brands-hero-banner');
    if (!heroBannerSection) return;

    const slideshowComponent = heroBannerSection.querySelector('slideshow-component');
    if (!slideshowComponent) return;

    const dots = slideshowComponent.querySelectorAll('.slider-counter__link');
    const slider = slideshowComponent.querySelector('[id^="Slider-"]');

    if (!dots.length || !slider) return;

    // Add click event listeners to dots
    dots.forEach((dot, index) => {
      dot.addEventListener('click', function(e) {
        e.preventDefault();

        // Calculate the scroll position for the target slide
        const slides = slider.querySelectorAll('.slider__slide');
        if (slides[index]) {
          const targetPosition = slides[index].offsetLeft;
          slider.scrollTo({
            left: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });

    // Update active dot on scroll
    slider.addEventListener('scroll', function() {
      const slides = slider.querySelectorAll('.slider__slide');
      const scrollLeft = slider.scrollLeft;
      let activeIndex = 0;

      // Find the currently visible slide
      slides.forEach((slide, index) => {
        const slideLeft = slide.offsetLeft;
        const slideWidth = slide.offsetWidth;
        if (scrollLeft >= slideLeft - slideWidth / 2) {
          activeIndex = index;
        }
      });

      // Update active dot
      dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add('slider-counter__link--active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('slider-counter__link--active');
          dot.removeAttribute('aria-current');
        }
      });
    });

    // Set initial active dot
    if (dots.length > 0) {
      dots[0].classList.add('slider-counter__link--active');
      dots[0].setAttribute('aria-current', 'true');
    }
  }

  // Initialize after a short delay to ensure DOM is ready
  setTimeout(initHeroBannerDots, 100);
});
